module.exports = __webpack_public_path__ + "img/medium.3f4b9612.png";